<template>
  <div class="home">
    <div class="container">
      <div class="bat">
        <input
          id="addTable"
          type="button"
          value="Add Table"
          @click="addTable"
        />
        &nbsp;
        <input
          id="checkTable"
          type="button"
          value="Save Data"
          @click="checkTable('s')"
        />&nbsp;
        <input
          id="restoreTable"
          type="button"
          value="Restore Data"
          @click="checkTable('r')"
        />
        &nbsp;
        <!-- <input
          id="makeTable"
          type="button"
          value="Generate Migrations"
          @click="generateMigrationFile(tables)"
        />
        &nbsp; -->
        <input
          id="makeModel"
          type="button"
          value="Generate All"
          @click="generateAll(tables)"
        />
      </div>
      <div class="tab">
        <div
          v-for="(table, index) in tables"
          :key="index"
          class="table-container"
        >
          <div class="table-header">
            <input
              class="form-control"
              type="text"
              v-model="table.name"
              placeholder="Enter your table"
            />
            <input
              id="removeTable"
              type="button"
              value="-"
              @click="removeTable(index)"
            />
          </div>
          <input
            id="addField"
            type="button"
            value="+ Field"
            @click="addTableField(index)"
          />
          <div
            v-for="(field, fIndex) in table.fields"
            :key="fIndex"
            class="field-container"
          >
            <input
              class="form-control"
              type="text"
              v-model="field.name"
              placeholder="Enter your field"
            />
            <input
              class="form-control"
              type="text"
              v-model="field.type"
              placeholder="Enter your type"
            />
            <input
              class="form-control"
              type="text"
              v-model="field.attribute"
              placeholder="Enter your attribute"
            />
            <input
              class="form-control"
              type="text"
              v-model="field.joined_table"
              placeholder="Enter your joined_table"
            />
            <input
              id="removeField"
              type="button"
              value="-"
              @click="removeTableField(index, fIndex)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.tab {
  width: 100%;
}
.bat {
  margin-bottom: 10px;
}
.table-container {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.table-header {
  display: flex;
  align-items: center;
}
.field-container {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
input[type="text"] {
  width: 40%;
  padding: 8px 12px;
  margin: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
input[type="button"] {
  margin-left: 5px;
  padding: 5px 10px;
  border: none;
  background-color: #d9534f;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
input[type="button"]:hover {
  background-color: #c9302c;
}
</style>

<script>
export default {
  data() {
    return {
      tables: [],
    };
  },
  methods: {
    addTable() {
      this.tables.push({ name: "", fields: [] });
    },
    checkTable(type) {
      if (type === "s") {
        console.log("tables", this.tables);
        localStorage.setItem("tables", JSON.stringify(this.tables));
        console.log("localStorage", JSON.parse(localStorage.getItem("tables")));
      } else {
        console.log("localStorage", JSON.parse(localStorage.getItem("tables")));
        this.tables = JSON.parse(localStorage.getItem("tables")) || [];
        console.log("tables", this.tables);
      }
    },
    removeTable(index) {
      this.tables.splice(index, 1);
    },
    addTableField(index) {
      //this.tables[index].fields.push("");
      this.tables[index].fields.push({
        name: "",
        type: "",
        attribute: "",
        joined_table: "",
      });
    },
    removeTableField(tableIndex, fieldIndex) {
      this.tables[tableIndex].fields.splice(fieldIndex, 1);
    },
    generateMigrationUp(table) {
      let schema = `<?php

use Illuminate\\Support\\Facades\\Schema;
use Illuminate\\Database\\Schema\\Blueprint;
use Illuminate\\Database\\Migrations\\Migration;

return new class extends Migration {
    public function up() {
        Schema::create('${table.name}', function (Blueprint $table) {
            $table->id();
`;

      table.fields.forEach((field) => {
        let line = `            $table->${field.type}('${field.name}')`;

        if (field.joined_table) {
          line = `            $table->foreignId('${field.name}')->constrained('${field.joined_table}')`;
        }

        if (field.attribute) {
          line += `->${field.attribute}()`;
        }

        line += `;\n`;
        schema += line;
      });

      schema += `            $table->timestamps();
            $table->softDeletes();
        });
    }

    public function down() {
        Schema::dropIfExists('${table.name}');
    }
};`;
      console.log("Generated Migration:", schema);
      this.downloadFile(`${table.name}_migration.php`, schema);
      return schema;
    },

    downloadFile(filename, content) {
      const blob = new Blob([content], { type: "text/php" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    generateModelFile(table) {
      let content = `<?php

namespace App\\Models;

use Illuminate\\Database\\Eloquent\\Factories\\HasFactory;
use Illuminate\\Database\\Eloquent\\Model;

class ${table.name.charAt(0).toUpperCase() + table.name.slice(1)} extends Model
{
    use HasFactory;

    protected $fillable = [
      `;

      table.fields.forEach((field) => {
        content += `        '${field.name}',
      `;
      });

      content += `    ];
}`;

      // table.fields.forEach((field) => {
      //   if (field.joined_table) {
      //     line += `->constrained('${field.joined_table}')`;
      //   }
      //   if (field.attribute) {
      //     line += `->${field.attribute}()`;
      //   }
      //   line += `;\n`;
      // });

      this.downloadFile(
        `${table.name.charAt(0).toUpperCase() + table.name.slice(1)}.php`,
        content
      );
    },

    generateControllerFile(table) {
      let className = `${
        table.name.charAt(0).toUpperCase() + table.name.slice(1)
      }Controller`;
      let modelName = `${
        table.name.charAt(0).toUpperCase() + table.name.slice(1)
      }`;

      let content = `<?php

namespace App\\Http\\Controllers;

use App\\Models\\${modelName};
use Illuminate\\Http\\Request;
use Illuminate\\Support\\Facades\\Log;

class ${className} extends Controller
{
    public function index()
    {
        try {
            $data = ${modelName}::all();
            return response()->json(['status' => true, 'message' => 'Data retrieved successfully', 'data' => $data]);
        } catch (\\Exception $e) {
            Log::error($e->getMessage());
            return response()->json(['status' => false, 'message' => 'Failed to retrieve data'], 500);
        }
    }

    public function show($id)
    {
        try {
            $data = ${modelName}::find($id);
            if (!$data) {
                return response()->json(['status' => false, 'message' => '${modelName} not found'], 404);
            }
            return response()->json(['status' => true, 'message' => 'Data retrieved successfully', 'data' => $data]);
        } catch (\\Exception $e) {
            Log::error($e->getMessage());
            return response()->json(['status' => false, 'message' => 'Failed to retrieve data'], 500);
        }
    }

    public function store(Request $request)
    {
        try {
            $validated = $request->validate([
                ${table.fields
                  .map((field) => `'${field.name}' => 'required'`)
                  .join(",\n                ")}
            ]);

            $entity = new ${modelName}();
            ${table.fields
              .map(
                (field) => `$entity->${field.name} = $request->${field.name};`
              )
              .join("\n            ")}
            $entity->save();

            return response()->json(['status' => true, 'message' => '${modelName} created successfully', 'data' => $entity], 201);
        } catch (\\Exception $e) {
            Log::error($e->getMessage());
            return response()->json(['status' => false, 'message' => 'Failed to create ${modelName}'], 500);
        }
    }

    public function update(Request $request, $id)
    {
        try {
            $data = ${modelName}::find($id);
            if (!$data) {
                return response()->json(['status' => false, 'message' => '${modelName} not found'], 404);
            }

            $validated = $request->validate([
                ${table.fields
                  .map((field) => `'${field.name}' => 'sometimes'`)
                  .join(",\n                ")}
            ]);

            ${table.fields
              .map(
                (field) =>
                  `$data->${field.name} = $request->${field.name} ?? $data->${field.name};`
              )
              .join("\n            ")}
            $data->save();

            return response()->json(['status' => true, 'message' => '${modelName} updated successfully', 'data' => $data]);
        } catch (\\Exception $e) {
            Log::error($e->getMessage());
            return response()->json(['status' => false, 'message' => 'Failed to update ${modelName}'], 500);
        }
    }

    public function destroy($id)
    {
        try {
            $data = ${modelName}::find($id);
            if (!$data) {
                return response()->json(['status' => false, 'message' => '${modelName} not found'], 404);
            }

            $data->delete();
            return response()->json(['status' => true, 'message' => '${modelName} deleted successfully']);
        } catch (\\Exception $e) {
            Log::error($e->getMessage());
            return response()->json(['status' => false, 'message' => 'Failed to delete ${modelName}'], 500);
        }
    }
}`;

      this.downloadFile(`${className}.php`, content);
    },

    generateAll() {
      this.tables.forEach((table) => {
        this.generateModelFile(table);
        this.generateMigrationUp(table);
        this.generateControllerFile(table);
      });
    },
  },
};
</script>
